import React from 'react';
import { Popper, PopperTrigger, PopperContent } from '@cp/src/components/Popper/Popper';
import PersonIcon from '@cp/src/assets/images/icons/PersonIcon';
import LonghornInfoPopover from './LonghornInfoPopover';
import { getSourceLabel } from '../../Addresses/contants';
import { Address, SimilarLocation } from '../interfaces';
import dayjs from 'dayjs';
import { DateFormat } from '@cp/src/utils/DateHelper';

interface LonghornInfoPopperProps {
  addressEntity: Address | SimilarLocation;
  onViewProof: (source: string, proofOfSourceUrl: string) => void;
  iconSize?: number;
  buttonClassName?: string;
}

const LonghornInfoPopper: React.FC<LonghornInfoPopperProps> = ({
  addressEntity,
  onViewProof,
  iconSize,
  buttonClassName = 'inline-flex items-center justify-center bg-transparent border-none cursor-pointer'
}) => {
  const formattedDate = addressEntity.capturedAt
    ? dayjs(addressEntity.capturedAt).format(DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME)
    : '';

  const handleViewProof = () => {
    onViewProof(addressEntity.secondarySource, addressEntity.metadata?.proofOfSourceUrl || '');
  };

  return (
    <Popper placement="bottom" hideStrategy="referenceHidden" crossAxisOffset={120}>
      <PopperTrigger>
        <button type="button" className={buttonClassName}>
          <PersonIcon width={iconSize} height={iconSize} />
        </button>
      </PopperTrigger>
      <PopperContent
        headerText="Address added by"
        arrowColor="var(--orange-oldlase)"
        className="popperWrapper"
        style={{ zIndex: 1301 }}
      >
        <LonghornInfoPopover
          name={addressEntity.metadata?.addedByName || ''}
          email={addressEntity.metadata?.addedByEmail || ''}
          updatedOn={formattedDate}
          source={getSourceLabel(addressEntity.secondarySource || '')}
          onViewProof={handleViewProof}
        />
      </PopperContent>
    </Popper>
  );
};

export default LonghornInfoPopper;
